import { useIntl } from 'react-intl';
import { Divider, Form } from 'antd';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import ForecastPayableForm from '@/components/Registry/BillToPay/ForecastPayableForm';
import { useForecastPayableCreate } from '@/core/domain/financial/ForecastPayable/ForecastPayable.hooks';
import {
  ForecastPayableCreateRequest,
  ForecastPayableFormValues,
} from '@/core/domain/financial/ForecastPayable/ForecastPayable.types';
import { useHistory } from 'react-router';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

function ForecastPayableCreatePage({ route }: PageProps) {
  const history = useHistory();
  const intl = useIntl();
  const [form] = Form.useForm<ForecastPayableFormValues>();

  const createMutation = useForecastPayableCreate();

  const handleCreate = async () => {
    const values = await form.validateFields();

    const obj: ForecastPayableCreateRequest = {
      ...values,
      employeeId: values.employeeId ?? undefined,
      supplierId: values.supplierId ?? undefined,
    };

    const response = await createMutation.mutateAsync(obj);

    history.push(`/app/financial/billToPay/forecastPayable/${response.id}`);
  };

  return (
    <TabContentWrapper
      title={route.name}
      permissions={route.permissions}
      extra={
        <SaveButton
          type="primary"
          loading={createMutation.isLoading}
          onClick={handleCreate}
          block
          disabled={
            !hasPermissions([
              Authorities.FINANCIAL_ACCOUNT_PAYABLE_ADD_FORECAST_OF_ACCOUNTS_PAYABLE,
            ])
          }
        >
          {intl.formatMessage({ id: 'commons.form.button.save' })}
        </SaveButton>
      }
    >
      <ForecastPayableForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/financial/billToPay/forecastPayable" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default ForecastPayableCreatePage;
